import { CustomQRCodeType } from "./type";
import lazyLoad from "../../utils/lazyLoad";
import { useCopies } from "../../hooks/useCopies";
import React, { Suspense } from "react";
const CustomQRCodeBase = lazyLoad(() => import("./customQRCodeBase"));

export default function CustomQRCode(props: CustomQRCodeType) {
  const copies = useCopies();

  return (
    <Suspense
      fallback={
        <div
          className="displayQrCodeFallback"
          style={{
            height: props.size,
            width: props.size
          }}>
          {copies.get("loading")}...
        </div>
      }>
      <div>
        <CustomQRCodeBase {...props} />
      </div>
    </Suspense>
  );
}
